import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { APPSTORE, PLAYSTORE, UserService } from '@app/core';
import { CommonService } from '@app/core/services/common.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  playstore = PLAYSTORE;
  appstore = APPSTORE;
  platform = this._common.getOS();
  showPopup: boolean = false;  // New property to control popup visibility

  constructor(
    private _activated: ActivatedRoute,
    private _toast: ToastrService,
    public _user: UserService,
    public _common: CommonService
  ) {
    this._common.checkRouterData(this._activated.snapshot.data);
    if (this._activated.snapshot.queryParams['payment']) {
      let status = this._activated.snapshot.queryParams['payment'];
      if (
        status &&
        sessionStorage.getItem('payment') &&
        status == sessionStorage.getItem('payment')
      ) {
        location.href = '/';
      } else if (status) {
        this.showMsg(status);
        sessionStorage.setItem('payment', status);
      }
    }
  }

  async ngOnInit() {
    // Show the popup after 3 seconds delay
    setTimeout(() => {
      this.showPopup = true;  // Trigger the popup to show
    }, 3000);
  }

  showMsg(status: string) {
    if (status == 'success') {
      this._toast.success('Payment success');
    } else if (status == 'failed') {
      this._toast.error('Payment failed');
    }
  }

  openPopup() {
    this.showPopup = true;  // You can manually open the popup if needed
  }

  closePopup() {
    this.showPopup = false;  // You can close the popup when needed
  }
}
